// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { L10n } from '../L10n/L10n';
import { IExtractTaskInfo } from '../models/IExtractTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ExtractTasks } from '../resources/ExtractTasks';
import { AbstractContentAction } from './AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export class ResumeExtractTasksAction extends AbstractContentAction<IExtractTaskInfo> {

  public static $inject = ['ConfirmActionDialog', 'ContentActionNotification', '$translate', 'ExtractTasks'];

  constructor(
            ConfirmActionDialog: ConfirmActionDialog,
            ContentActionNotification: ContentActionNotification,
    private $translate: ng.translate.ITranslateService,
    private ExtractTasks: ExtractTasks
  ) {
    super(ConfirmActionDialog, ContentActionNotification);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, extractTasks: Set<IExtractTaskInfo>) {
    const extractTaskCount = extractTasks.size();
    if (extractTaskCount === 1) {
      const extractTask = extractTasks.first();
      if (extractTask.workbook) {
        dialogConfig.bodyText = this.$translate.instant('extractTaskForResumePausedWorkbookPrompt', {
          WORKBOOK_NAME: L10n.elideIfLong(extractTask.workbook.name)
        });
      } else {
        dialogConfig.bodyText = this.$translate.instant('extractTaskForResumePrompt', {
          ITEM_COUNT: extractTaskCount
        }, L10n.Interpolations.Count);
      }
    } else {
      dialogConfig.bodyText = this.$translate.instant('extractTaskForResumePrompt', {
        ITEM_COUNT: extractTaskCount
      }, L10n.Interpolations.Count);
    }
    dialogConfig.title = this.$translate.instant('resumeNow');
    dialogConfig.actionName = this.$translate.instant('resumeNowConfirmButton', {
      ITEM_COUNT: extractTaskCount
    }, L10n.Interpolations.Count);
    dialogConfig.action = () => this.ExtractTasks.resume(extractTasks.keys());
  }

  notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'extractTasksResumeSuccess',
      errorId: 'extractTasksResumeError'
    };
  }

}

Module.instance().service('ResumeExtractTasksAction', ResumeExtractTasksAction);
